import appConfig from './app-config';

const amplifyConfig = {
    aws_cognito_region: appConfig.aws.cognitoRegion,
    aws_user_pools_id: appConfig.aws.userPoolsId,
    aws_user_pools_web_client_id: appConfig.aws.userPoolsWebClientId
};

export default amplifyConfig;
